import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  ACCESS_APPLICATIONS,
  ACCESS_INVESTORS,
  ACCESS_MAINTENANCE_REPORTS,
  ACCESS_PROPERTIES,
  ACCESS_PROSPECTS,
  ACCESS_PROPERTY_MANAGEMENT,
  ACCESS_RENT_PAYMENTS,
  ACCESS_RENTALS,
  ACCESS_TENANTS,
  ACCESS_STATISTICS_MENU,
  ACCESS_USERS,
  usePermissions,
} from '../hooks/usePermissions';
import { Dashboard } from './Dashboard';

/**
 * Punto de entrada en /. Redirige según permisos cuando no aplica el dashboard.
 */
export const HomeEntry: React.FC = () => {
  const { hasPermission, hasAnyPermission } = usePermissions();

  if (hasPermission('view_dashboard')) {
    return <Dashboard />;
  }

  // Orden consistente con el menú lateral (cuando no hay dashboard)
  if (hasAnyPermission([...ACCESS_PROPERTIES])) {
    return <Navigate to="/propiedades" replace />;
  }

  if (
    hasAnyPermission([...ACCESS_APPLICATIONS]) ||
    hasAnyPermission([...ACCESS_PROSPECTS]) ||
    hasAnyPermission([...ACCESS_TENANTS]) ||
    hasAnyPermission([...ACCESS_RENT_PAYMENTS])
  ) {
    if (hasAnyPermission([...ACCESS_APPLICATIONS])) {
      return <Navigate to="/rentas/solicitudes" replace />;
    }
    if (hasAnyPermission([...ACCESS_PROSPECTS])) {
      return <Navigate to="/rentas/prospectos" replace />;
    }
    if (hasAnyPermission([...ACCESS_TENANTS])) {
      return <Navigate to="/rentas/inquilinos" replace />;
    }
    if (hasAnyPermission([...ACCESS_RENT_PAYMENTS])) {
      return <Navigate to="/rentas/pagos" replace />;
    }
    return <Navigate to="/configuracion" replace />;
  }

  if (hasAnyPermission([...ACCESS_INVESTORS])) {
    return <Navigate to="/inversionistas" replace />;
  }

  if (hasAnyPermission([...ACCESS_MAINTENANCE_REPORTS])) {
    return <Navigate to="/maintenance" replace />;
  }

  if (hasAnyPermission(['view_tenant_portal', 'view_tenant_account'])) {
    return <Navigate to="/inquilino" replace />;
  }

  if (hasPermission('investor_account') || hasPermission('view_investor_account')) {
    return <Navigate to="/mi-cuenta" replace />;
  }

  if (hasAnyPermission([...ACCESS_STATISTICS_MENU])) {
    // Por default, entrar al dashboard de estadísticas si lo tiene; si no, al módulo padre
    if (hasAnyPermission(['view_statistics', 'view_statistics_dashboard'])) {
      return <Navigate to="/estadisticas/dashboard" replace />;
    }
    return <Navigate to="/estadisticas" replace />;
  }

  if (hasAnyPermission([...ACCESS_PROPERTY_MANAGEMENT])) {
    return <Navigate to="/property-management" replace />;
  }

  if (hasAnyPermission([...ACCESS_USERS])) {
    return <Navigate to="/usuarios" replace />;
  }

  if (hasAnyPermission(['view_fideicomiso'])) {
    return <Navigate to="/kyc" replace />;
  }

  if (hasPermission('manage_settings')) {
    return <Navigate to="/configuracion-sistema" replace />;
  }

  return <Navigate to="/configuracion" replace />;
};
